export default "__VITE_ASSET__mDQS6JhC__"